import * as PIXI from 'pixi.js'

class Background {
  constructor (game) {
    this.defaultColor = '#d8eaef'
    this.sound = null
    this.game = game
    this.ticker = new PIXI.ticker.Ticker()
  }

  init () {
    this.set(this.defaultColor)
    this.bg = new PIXI.extras.TilingSprite(PIXI.Texture.from('bg'), this.game.app.renderer.width, this.game.app.renderer.height)
    this.bg.tileScale.set(0.25)
    this.game.app.stage.addChild(this.bg)

    this.ticker.add(deltaTime => {
      this.bg.tilePosition.y += (1 * deltaTime)

      // 151.75 is magic!
      if (this.bg.tilePosition.y >= 151.75) {
        this.bg.tilePosition.y = 0
      }
    })
    this.ticker.start()
  }

  set (color) {
    this.game.app.view.style.backgroundColor = color
    return this
  }

  setTextureAlpha (alpha) {
    this.bg.alpha = alpha
    return this
  }

  playBGM () {
    // clear track before play sound
    this.stopBGM()

    if (this.game.audioEnabled) {
      this.sound = PIXI.sound.play('audioBackground')
      this.sound.volume = 1
      this.sound.loop = true
    }
  }

  stopBGM () {
    if (this.sound) {
      this.sound.stop()
      this.sound.destroy()
      this.sound = null
    }

    if (this.bgmTicker) {
      this.bgmTicker.stop()
      this.bgmTicker.destroy()
      this.bgmTicker = null
    }
  }

  pauseBGM () {
    if (this.sound) {
      PIXI.sound.pause('audioBackground')
    }
  }

  resumeBGM () {
    if (this.sound) {
      PIXI.sound.resume('audioBackground')
    }
  }

  fadeOutBGM () {
    this.bgmTicker = new PIXI.ticker.Ticker()
    this.bgmTicker.add(deltaTime => {
      this.sound.volume -= 0.01 * deltaTime

      if (this.sound.volume <= 0) {
        this.stopBGM()
      }
    })
    this.bgmTicker.start()
  }
}

export default Background
